import { qualityManage } from '@/api/index'

export function Add_REFEREE (data) {
  return qualityManage.request({
    method: 'post',
    url: '/Add_REFEREE',
    data
  })
}

export function BILLNO_getunit (data) {
  return qualityManage.request({
    method: 'post',
    url: '/BILLNO_getunit',
    data
  })
}
export function AddCargodamageInfo (data) {
  return qualityManage.request({
    method: 'post',
    url: '/AddCargodamageInfo',
    data
  })
}
export function GetCargodamageInfo (data) {
  return qualityManage.request({
    method: 'post',
    url: '/GetCargodamageInfo',
    data
  })
}

export function DeleteCargodamage (data) {
  return qualityManage.request({
    method: 'post',
    url: '/DeleteCargodamage',
    data
  })
}
export function CancelRShipment (data) {
  return qualityManage.request({
    method: 'post',
    url: '/CancelRShipment',
    data
  })
}
